import * as React from 'react';
import { toast } from 'react-toastify';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import EnhancedDataGrid from '../Common/EnhancedDataGrid'; import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';

export default class CostCodes extends React.Component {
	constructor() {
		super();

		this.state = {
			data: [],
			lastUpdated: ""
		};
		this.refresh_clickHandler = this.refresh_clickHandler.bind(this);
	}

	componentDidMount() {
		this.fetchCostCodes();
	}
	getRefreshButton = () => {
		return <IconButton
			variant="contained"
			onClick={this.refresh_clickHandler}
			size="small"
			style={{ float: "right", zIndex: 1, marginTop: 10, display: 'none' }}>
			<RefreshIcon />
		</IconButton>;
	}

	refresh_clickHandler(event) {
		this.props.info.inProgress(true);
		let functionName = "getcostcode";
		let messageName = "Cost Codes";
		httpGet("/api/Adapter/getSyncData/" +functionName)
			.then(response => {
				var data = response.data;
				this.props.info.inProgress(false);
				if (data)
					toast.success(messageName +' Fetched Successfully');
				else
					toast.error('Error fetching ' + messageName);

			}).catch((error) => {
				this.props.info.inProgress(false);
				toast.error('Error fetching ' + messageName);
			});
	}
	fetchCostCodes() {
		var that = this;

		this.props.info.inProgress(true);

		httpGet('/api/setup/costcodes/' + this.props.info.costType)
			.then((response) => {
				var data = response.data;

				var localDateString = data.lastUpdated == null ? "" : new Date(data.lastUpdated).toLocaleString();
				let records = (data.records || []).map((e, i) => { let d = { ...e, rowId: i }; return d; });
				that.setState({ data: records, lastUpdated: localDateString });

				this.props.info.inProgress(false);
			})
			.catch((error) => {
				this.props.info.inProgress(false);
				toast.error('An error occurred while fetching the records');
				console.error('There was an error!', error);
			});
	}

	render() {
		return (
			<div>
				<h1>Expense Types {this.props.info.costType && <span>({this.props.info.costType })</span>}</h1>
				<div className="form-group">
					<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
						<EnhancedDataGrid rows={this.state.data}
							disableColumnMenu
							pagination
							pageSize={10}
							title={"Last Updated: " + this.state.lastUpdated}
							customcomponent={this.getRefreshButton()}
							columns={[
								{
									headerName: 'Res Type',
									field: 'resType',
									flex: 0.5,
									width: 50
								},
								{
									headerName: 'Name',
									field: 'rTypeName',
									flex: 1,
								},
								{
									headerName: 'Description',
									field: 'rTypeDescription',
									flex: 1
								},
								{
									headerName: 'Effective Date',
									field: 'effectiveDate',
									type: 'date',
									valueGetter: ({ value }) =>  value && new Date(value),
									flex: 1
								}
								
							]}
							getRowId={(row) => row.rowId}
							disableSelectionOnClick
						/>
					</div>
				</div>
			</div>
		);
	}
}
